import type * as lazyIndex from "./lazyIndex";
import { LazyModule, LazyAction } from "owa-bundling-light";

const lazyModule: LazyModule<typeof lazyIndex> = new LazyModule<typeof lazyIndex>(() => import(/* webpackChunkName: "AppModuleHelpers"*/ "./lazyIndex"), { name: "AppModuleHelpers" });

export const lazyEvaluateAutoUpdateFavicon: LazyAction<typeof lazyIndex.evaluateAutoUpdateFavicon, typeof lazyModule> = new LazyAction(lazyModule, m => m.evaluateAutoUpdateFavicon);
